import {
  GET_FINISHEDGOODS_REQUEST,
  GET_FINISHEDGOODS_SUCCESS,
  GET_FINISHEDGOODS_FAILURE,
  GET_GROUPED_FINISHEDGOODS_REQUEST,
  GET_GROUPED_FINISHEDGOODS_SUCCESS,
  GET_GROUPED_FINISHEDGOODS_FAILURE,
  GET_VINBYFGCODE_REQUEST,
  GET_VINBYFGCODE_SUCCESS,
  GET_VINBYFGCODE_FAILURE,
  CREATE_PICKLIST_FOR_SUID_REQUEST,
  CREATE_PICKLIST_FOR_SUID_SUCCESS,
  CREATE_PICKLIST_FOR_SUID_FAILURE,
  CREATE_PICKLIST_FOR_QTY_REQUEST,
  CREATE_PICKLIST_FOR_QTY_SUCCESS,
  CREATE_PICKLIST_FOR_QTY_FAILURE,
  CREATE_PICKLIST_FOR_VIN_REQUEST,
  CREATE_PICKLIST_FOR_VIN_SUCCESS,
  CREATE_PICKLIST_FOR_VIN_FAILURE,
  GET_SUIDS_FOR_FG_REQUEST,
  GET_SUIDS_FOR_FG_SUCCESS,
  GET_SUIDS_FOR_FG_FAILURE,
  GET_ITEMS_FOR_FG_REQUEST,
  GET_ITEMS_FOR_FG_SUCCESS,
  GET_ITEMS_FOR_FG_FAILURE,
  GET_FG_CODE_FOR_DOCUMENT_REQUEST,
  GET_FG_CODE_FOR_DOCUMENT_SUCCESS,
  GET_FG_CODE_FOR_DOCUMENT_FAILURE,
  GET_SFG_REQUEST,
  GET_SFG_SUCCESS,
  GET_SFG_FAILURE,
  GET_SFG_FINISHED_REQUEST,
  GET_SFG_FINISHED_SUCCESS,
  GET_SFG_FINISHED_FAILURE,
  GET_VINS_REQUEST,
  GET_VINS_SUCCESS,
  GET_VINS_FAILURE,
  GET_FINISHEDGOODS_FOR_DOWNLOAD_REQUEST,
  GET_FINISHEDGOODS_FOR_DOWNLOAD_FAILURE,
  GET_FINISHEDGOODS_FOR_DOWNLOAD_SUCCESS,
  GET_FINISHEDGOODS_WITHOUT_PAGINATION_REQUEST,
  GET_FINISHEDGOODS_WITHOUT_PAGINATION_SUCCESS,
  GET_FINISHEDGOODS_WITHOUT_PAGINATION_FAILURE,
} from "./fgTransactionTypes";
import axios from "axios";
import Config from "../../config/index";

let baseUrl = Config.baseUrl;

const getFinishedGoodsRequest = () => {
  return {
    type: GET_FINISHEDGOODS_REQUEST,
  };
};

const getFinishedGoodsSuccess = (payload) => {
  return {
    type: GET_FINISHEDGOODS_SUCCESS,
    payload: payload,
  };
};

const getFinishedGoodsFailure = (error) => {
  return {
    type: GET_FINISHEDGOODS_FAILURE,
    payload: error,
  };
};

const getFinishedGoods = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFinishedGoodsRequest());
    let url = `${baseUrl}/fg_transaction/get_all_without_grp?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFinishedGoodsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFinishedGoodsFailure(err.message));
      });
  };
};

const getSfgRequest = () => {
  return {
    type: GET_SFG_REQUEST,
  };
};

const getSfgSuccess = (payload) => {
  return {
    type: GET_SFG_SUCCESS,
    payload: payload,
  };
};

const getSfgFailure = (error) => {
  return {
    type: GET_SFG_FAILURE,
    payload: error,
  };
};

const getSfg = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSfgRequest());
    let url = `${baseUrl}/fg_transaction/get_all_for_SFG?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    // /fg_transaction/get_all_for_SFG?page_number=1&rows_per_page=10&search=
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSfgSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSfgFailure(err.message));
      });
  };
};

const getGroupedFinishedGoodsRequest = () => {
  return {
    type: GET_GROUPED_FINISHEDGOODS_REQUEST,
  };
};

const getGroupedFinishedGoodsSuccess = (payload) => {
  return {
    type: GET_GROUPED_FINISHEDGOODS_SUCCESS,
    payload: payload,
  };
};

const getGroupedFinishedGoodsFailure = (error) => {
  return {
    type: GET_GROUPED_FINISHEDGOODS_FAILURE,
    payload: error,
  };
};

const getGroupedFinishedGoods = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getGroupedFinishedGoodsRequest());
    let url = `${baseUrl}/fg_transaction/get_all?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getGroupedFinishedGoodsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getGroupedFinishedGoodsFailure(err.message));
      });
  };
};

const getSfgForFinishedGoodsRequest = () => {
  return {
    type: GET_SFG_FINISHED_REQUEST,
  };
};

const getSfgForFinishedGoodsSuccess = (payload) => {
  return {
    type: GET_SFG_FINISHED_SUCCESS,
    payload: payload,
  };
};

const getSfgForFinishedGoodsFailure = (error) => {
  return {
    type: GET_SFG_FINISHED_FAILURE,
    payload: error,
  };
};

const getSfgForFinishedGoods = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSfgForFinishedGoodsRequest());
    let url = `${baseUrl}/fg_transaction/get_all_for_SFG?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSfgForFinishedGoodsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSfgForFinishedGoodsFailure(err.message));
      });
  };
};

const getVinByFgcodeRequest = () => {
  return {
    type: GET_VINBYFGCODE_REQUEST,
  };
};

const getVinByFgcodeSuccess = (payload) => {
  return {
    type: GET_VINBYFGCODE_SUCCESS,
    payload: payload,
  };
};

const getVinByFgcodeFailure = (error) => {
  return {
    type: GET_VINBYFGCODE_FAILURE,
    payload: error,
  };
};

const getVinByFgCode = (fgCode, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVinByFgcodeRequest());
    let url = `${baseUrl}/fg_transaction/get_vin_by_fgcode?fgCode=${fgCode}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVinByFgcodeSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getVinByFgcodeFailure(err.message));
      });
  };
};

const createPicklistForVinRequest = () => {
  return {
    type: CREATE_PICKLIST_FOR_VIN_REQUEST,
  };
};

const createPicklistForVinSuccess = (payload) => {
  return {
    type: CREATE_PICKLIST_FOR_VIN_SUCCESS,
    payload: payload,
  };
};

const createPicklistForVinFailure = (error) => {
  return {
    type: CREATE_PICKLIST_FOR_VIN_FAILURE,
    payload: error,
  };
};

const createPicklistForVin = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createPicklistForVinRequest());
    let url = `${baseUrl}/fg_transaction/create_picklist`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPicklistForVinSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPicklistForVinFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createPicklistForSuidRequest = () => {
  return {
    type: CREATE_PICKLIST_FOR_SUID_REQUEST,
  };
};

const createPicklistForSuidSuccess = (payload) => {
  return {
    type: CREATE_PICKLIST_FOR_SUID_SUCCESS,
    payload: payload,
  };
};

const createPicklistForSuidFailure = (error) => {
  return {
    type: CREATE_PICKLIST_FOR_SUID_FAILURE,
    payload: error,
  };
};

const createPicklistForSuid = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createPicklistForSuidRequest());
    let url = `${baseUrl}/fg/picklist/create_with_suids`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPicklistForSuidSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPicklistForSuidFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createPicklistForQtyRequest = () => {
  return {
    type: CREATE_PICKLIST_FOR_QTY_REQUEST,
  };
};

const createPicklistForQtySuccess = (payload) => {
  return {
    type: CREATE_PICKLIST_FOR_QTY_SUCCESS,
    payload: payload,
  };
};

const createPicklistForQtyFailure = (error) => {
  return {
    type: CREATE_PICKLIST_FOR_QTY_FAILURE,
    payload: error,
  };
};

const createPicklistForQty = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createPicklistForQtyRequest());
    let url = `${baseUrl}/fg/picklist/create_with_qty`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPicklistForQtySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPicklistForQtyFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getSuidsForFgRequest = () => {
  return {
    type: GET_SUIDS_FOR_FG_REQUEST,
  };
};

const getSuidsForFgSuccess = (payload) => {
  return {
    type: GET_SUIDS_FOR_FG_SUCCESS,
    payload: payload,
  };
};

const getSuidsForFgFailure = (error) => {
  return {
    type: GET_SUIDS_FOR_FG_FAILURE,
    payload: error,
  };
};

const getSuidsForFg = (itemId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSuidsForFgRequest());
    let url = `${baseUrl}/fg/picklist/get_suids?fgCode=${itemId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSuidsForFgSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSuidsForFgFailure(err.message));
      });
  };
};

const getItemsForFgRequest = () => {
  return {
    type: GET_ITEMS_FOR_FG_REQUEST,
  };
};

const getItemsForFgSuccess = (payload) => {
  return {
    type: GET_ITEMS_FOR_FG_SUCCESS,
    payload: payload,
  };
};

const getItemsForFgFailure = (error) => {
  return {
    type: GET_ITEMS_FOR_FG_FAILURE,
    payload: error,
  };
};

const getItemsForFg = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getItemsForFgRequest());
    let url = `${baseUrl}/fg/get_items`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getItemsForFgSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getItemsForFgFailure(err.message));
      });
  };
};

const getFgCodeForDocumentRequest = () => {
  return {
    type: GET_FG_CODE_FOR_DOCUMENT_REQUEST,
  };
};

const getFgCodeForDocumentSuccess = (payload) => {
  return {
    type: GET_FG_CODE_FOR_DOCUMENT_SUCCESS,
    payload: payload,
  };
};

const getFgCodeForDocumentFailure = (error) => {
  return {
    type: GET_FG_CODE_FOR_DOCUMENT_FAILURE,
    payload: error,
  };
};

const getFgCodeForDocument = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFgCodeForDocumentRequest());
    let url = `${baseUrl}/fg/get_fgCodes`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFgCodeForDocumentSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getFgCodeForDocumentFailure(err.message));
      });
  };
};

const getVinsForFgRequest = () => {
  return {
    type: GET_VINS_REQUEST,
  };
};

const getVinsForFgSuccess = (payload) => {
  return {
    type: GET_VINS_SUCCESS,
    payload: payload,
  };
};

const getVinsForFgFailure = (error) => {
  return {
    type: GET_VINS_FAILURE,
    payload: error,
  };
};

const getVinsForFg = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVinsForFgRequest());
    let url = `${baseUrl}/fg_transaction/get_list_of_vin`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVinsForFgSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVinsForFgFailure(err.message));
      });
  };
};

const getFinishedGoodsForDownloadRequest = () => {
  return {
    type: GET_FINISHEDGOODS_FOR_DOWNLOAD_REQUEST,
  };
};

const getFinishedGoodsForDownloadSuccess = (payload) => {
  return {
    type: GET_FINISHEDGOODS_FOR_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getFinishedGoodsForDownloadFailure = (error) => {
  return {
    type: GET_FINISHEDGOODS_FOR_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getFinishedGoodsForDownload = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFinishedGoodsForDownloadRequest());
    let url = `${baseUrl}/fg_transaction/get_all_without_grp?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=1`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFinishedGoodsForDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFinishedGoodsForDownloadFailure(err.message));
      });
  };
};

const getFinishedGoodsWithoutPaginationRequest = () => {
  return {
    type: GET_FINISHEDGOODS_WITHOUT_PAGINATION_REQUEST,
  };
};

const getFinishedGoodsWithoutPaginationSuccess = (payload) => {
  return {
    type: GET_FINISHEDGOODS_WITHOUT_PAGINATION_SUCCESS,
    payload: payload,
  };
};

const getFinishedGoodsWithoutPaginationFailure = (error) => {
  return {
    type: GET_FINISHEDGOODS_WITHOUT_PAGINATION_FAILURE,
    payload: error,
  };
};

const getFinishedGoodsWithoutPagination = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFinishedGoodsWithoutPaginationRequest());
    let url = `${baseUrl}/`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFinishedGoodsWithoutPaginationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFinishedGoodsWithoutPaginationFailure(err.message));
      });
  };
};

export {
  getFinishedGoods,
  getGroupedFinishedGoods,
  getVinByFgCode,
  createPicklistForVin,
  createPicklistForSuid,
  createPicklistForQty,
  getSuidsForFg,
  getItemsForFg,
  getFgCodeForDocument,
  getSfg,
  getSfgForFinishedGoods,
  getVinsForFg,
  getFinishedGoodsForDownload,
  getFinishedGoodsWithoutPagination,
};
